import moment from "moment";

export function isNullOrWhitespace(value) {
    return value == null || value === "";
}

export function isNotNullOrWhitespace(value) {
    return !isNullOrWhitespace(value);
}

export function getValueOrWhitespace(valueToCheck, defaultValueToReturn = "") {
    if (valueToCheck == null) {
        return defaultValueToReturn;
    } else {
        return valueToCheck;
    }
}

export function getFormattedAddress(address) {
    if (address == null) {
        return "";
    }

    let addressString = "";

    addressString = address.line1;
    if (!isNullOrWhitespace(address.line2)) {
        addressString += `, ${address.line2}`;
    } else if (!isNullOrWhitespace(address.line3)) {
        addressString += ` ${address.line3}`;
    }
    addressString += ` ${address.city} - ${address.state} ${address.zipCode}`;

    return addressString;
}

export function getFormattedName(firstName, middleName, lastName, suffix, defaultValue = "") {
    let name = defaultValue;
    if (isNotNullOrWhitespace(firstName)) {
        name = firstName;
    }
    if (isNotNullOrWhitespace(middleName)) {
        name += ` ${middleName}`;
    }

    if (isNotNullOrWhitespace(lastName)) {
        name += ` ${lastName}`;
    }

    if (isNotNullOrWhitespace(suffix)) {
        name += ` ${suffix}`;
    }

    return name;
}

export function getFormattedNameFromObject({ firstName, middleInitial, lastName, suffix }, defaultValue = "") {
    return getFormattedName(firstName, middleInitial, lastName, suffix, defaultValue);
}

export function formatSsn(ssn) {
    if (!ssn) {
        return "N/A";
    }

    return ssn.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");
}

export function formatPhone(phone) {
    if (!phone) {
        return "N/A";
    }

    return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
}

export function getCustomFormattedNameFromObject(
    { firstName, middleInitial, lastName, suffix, relationshipToPatient },
    defaultValue = "",
    showRelationship = false
) {
    let name = defaultValue;
    if (isNotNullOrWhitespace(firstName)) {
        name = firstName;
    }

    if (isNotNullOrWhitespace(suffix)) {
        name += ` (${suffix})`;
    }

    if (showRelationship) {
        if (isNotNullOrWhitespace(relationshipToPatient)) {
            if (relationshipToPatient === "Self") {
                name += ` (Patient)`;
            } else {
                name += ` (${relationshipToPatient})`;
            }
        }
    }

    return name;
}

export function getAge(dob) {
    return dob ? moment().diff(dob, "years") : "";
}

export function getProgramName(program) {
    return program.programDetails.Title || program.assistanceCategory;
}
